/** Summarize repricer_articles.pricing_history for compact UI display. */
export function formatPricingHistory(history) {
  if (!history || typeof history !== "object" || Array.isArray(history)) {
    return null;
  }

  const parts = Object.entries(history)
    .filter(([, entries]) => Array.isArray(entries) && entries.length > 0)
    .map(([channel, entries]) => {
      const dates = entries
        .map((entry) => entry?.date)
        .filter(Boolean)
        .join(", ");
      return dates ? `${channel} (${dates})` : `${channel}: ${entries.length}`;
    });

  return parts.length > 0 ? parts.join(" · ") : null;
}
